var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout-timer",class:_vm.state_class},[_vm._v(_vm._s(_vm.display))])
}
var staticRenderFns = []

export { render, staticRenderFns }